import React, { forwardRef } from "react";

type LeadFormSelectField = Omit<
  React.InputHTMLAttributes<HTMLSelectElement>,
  "className"
> & {
  label?: string;
  error?: string;
  required?: boolean;
  optionData: Object[];
  defaultOptionText: string;
};

const LeadFormSelectField = forwardRef<HTMLSelectElement, LeadFormSelectField>(
  (
    { label, error, required, optionData, defaultOptionText, ...inputParams },
    ref
  ) => {
    return (
      <div className="flex w-full flex-col sm:max-w-[320px]">
        <select
          defaultValue={""}
          {...inputParams}
          ref={ref}
          className="select-dropdown-arrow h-[44px] appearance-none rounded-[10px] border-[1px] border-solid border-white bg-transparent bg-white px-[11px] font-body text-[14px] leading-[20px] tracking-[0.28px] text-lightTeal outline-none focus:text-black [&_option]:text-black"
        >
          <option value="" key={99} disabled>
            {defaultOptionText}
          </option>
          {optionData.map((i: any) => {
            return (
              <option value={i.abbr} key={i.abbr}>
                {i.name}
              </option>
            );
          })}
        </select>
        <span className="pl-[2px] font-body text-[14px] font-bold text-[#FFFCFA]">
          {error}
        </span>
      </div>
    );
  }
);

export default LeadFormSelectField;
